import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  hideAllControls,
  setModal,
  showModal,
  pushInteractions,
  transilluminatorOpen, 
  toggleToolTipTransillimunatorControls,
  transilluminatorGelExmined,
  setGelInTransilluminator,
  setGelInScene,
  setGelOnShelf,
  toggleTransilluminatorControlsModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("transilluminator") &&
     state.notebook.protocolSection.scene.apparatus.transilluminator.some(
       transilluminator => transilluminator.id === ownProps.id
     )
  ){
 return {
      id: ownProps.id,
      open: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].open,
      on: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].on,
      containsGel: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].containsGel,
      gelExamined: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].gelExamined,
      showToolTipControls: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id - 1].showToolTipControls,
      showControlsModal: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id - 1].showControlsModal,

      interactionProps: {
        solutions: state.notebook.protocolSection.scene.apparatus.solutions,
        agaroseGel: state.notebook.protocolSection.scene.apparatus.agaroseGel
      },
      level: state.notebook.levelSelected.id,
      gelOrientation: state.notebook.protocolSection.scene.apparatus.gelBoxes[0].gelOrientation
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    transilluminatorOpen: (data) => {
      dispatch(transilluminatorOpen(data))
    }, 
    transilluminatorGelExmined: (data) => {
      dispatch(transilluminatorGelExmined(data))
    }, 
    setModal: (data) => {
      dispatch(setModal(data))
    }, 
    showModal: (data) => {
      dispatch(showModal(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    toggleToolTipTransillimunatorControls: (data) => {
      dispatch(toggleToolTipTransillimunatorControls(data))
    },
    toggleTransilluminatorControlsModal: (data) => {
      dispatch(toggleTransilluminatorControlsModal(data))
    },
    setGelInTransilluminator: (data) => {
      dispatch(setGelInTransilluminator(data))
    },
    setGelInScene: (data) => {
      dispatch(setGelInScene(data))
    },
    setGelOnShelf: (data) => {
      dispatch(setGelOnShelf(data))
    }
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
